import { useState, useCallback } from 'react';
import { EmojiPicker } from 'stream-chat-react/emojis';

import clsx from 'clsx';
import { FileUploadButton } from 'react-file-utils';
import {
  useMessageInputContext,
  ChatAutoComplete,
  AttachmentPreviewList,
} from 'stream-chat-react';

import { IconLightning, IconSendMessage } from '@getstream/ui-library/build';

import styles from './CustomInput.module.css';

export type Props = {};

export const CustomInput = (props: Props) => {
  const { handleSubmit, uploadNewFiles } = useMessageInputContext();

  return (
    <>
      <div className={styles.attachments}>
        <AttachmentPreviewList />
      </div>

      <div
        className={`str-chat__input-flat--send-button-active ${styles.gsChatInput}`}
      >
        <div className={styles.gsChatActions}>
          <div className={styles.gsChatFileUpload}>
            <FileUploadButton
              className={styles.gsChatIcon}
              handleFiles={uploadNewFiles}
            />
          </div>
          <EmojiPicker
            ButtonIconComponent={() => (
              <IconLightning className={styles.gsChatIcon} fill="#FFF" />
            )}
            pickerProps={{ theme: 'dark' }}
            popperOptions={{
              placement: 'top-start',
            }}
            pickerContainerClassName={styles.emojiPickerWrapper}
          />
        </div>
        <div className={styles.gsChatInputTextareaWrapper}>
          <ChatAutoComplete
            grow={true}
            rows={1}
            maxRows={5}
            placeholder="Send a message"
            additionalTextareaProps={{ style: { height: 'auto' } }}
          />
        </div>
        <div className={clsx(styles.gsChatActions, styles.gsChatSendButton)}>
          <button type="button" onClick={handleSubmit}>
            <IconSendMessage fill="#FFF" className={styles.gsChatIcon} />
          </button>
        </div>
      </div>
    </>
  );
};
